export const fonts = {
  defaultFont: 'Proxima Nova',
  semiBold: 'Proxima Nova Semibold',
  bold: 'Proxima Nova Bold',
  light: 'Proxima Nova Light',
}